import { FormErrors } from 'redux-form';
// import { rutValidator } from '../helpers/utils';

const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+\.[A-Z]/i;
const regexDate = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;
const regexPhone = /^(1|8)?[0-9]{10}$/i;
const regexCurp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
const regexLastName = /(([a-zA-Z\u00C0-\u017F]+)( [a-zA-Z\u00C0-\u017F]+))/i;

export default (values: any) => {
  const errors: FormErrors<any> = {};

  if (!values.firstName) {
    errors.firstName = 'Campo obligatorio';
  } else if(values.firstName.length > 30) {
    errors.firstName = 'No puedes escribir más de 30 caracteres';
  }

  if(values.middleName) {
    if (values.middleName.length > 15) {
      errors.middleName = 'No puedes escribir más de 15 caracteres';
    }
  }

  if (!values.lastName) {
    errors.lastName = 'Campo obligatorio';
  } else if(!regexLastName.test(values.lastName)) {
    errors.lastName = 'Debe ingresar ambos apellidos';
  } else if(values.lastName.length > 30) {
    errors.lastName = 'No puedes escribir más de 30 caracteres';
  }

  if (!values.documentId) {
    errors.documentId = 'Campo obligatorio';
  } else if (!regexCurp.test(values.documentId)) {
    errors.documentId = 'CURP inválido';
  } else if (values.documentId.length < 18) {
    errors.documentId = 'CURP inválido';
  }

  if (!values.birthdate) {
    errors.birthdate = 'Campo obligatorio';
  } else if (!regexDate.test(values.birthdate)) {
    errors.birthdate =
      'Formato de fecha inválido, el formato es dd-mm-aaaa y el año no debe ser menor de 1900';
  }

  if (!values.mail) {
    errors.mail = 'Campo obligatorio';
  } else if (!regexEmail.test(values.mail)) {
    errors.mail = 'Correo inválido';
  }

  // 00+52+1+CÓDIGO DE ÁREA+NÚMERO CELULAR (8 DÍGITOS)
  if (!values.phone) {
    errors.phone = 'Campo obligatorio';
  } else if (values.phone.trim().length < 10) {
    errors.phone = 'Teléfono inválido, debe contener al menos 10 digitos';
  } else if (!regexPhone.test(values.phone.trim())) {
    errors.phone = 'El teléfono debe empezar por 1 u 8';
  }

  if (!values.genre) {
    errors.genre = 'Debe seleccionar su género';
  }

  if (!values.address) {
    errors.address = 'Campo obligatorio';
  } else if(values.address.length > 30) {
    errors.address = 'No puedes escribir más de 30 caracteres';
  }

  if (!values.addressNumber) {
    errors.addressNumber = 'Campo obligatorio';
  } else if(values.addressNumber.length > 10) {
    errors.addressNumber = 'No puedes escribir más de 10 caracteres';
  }

  if (!values.zipcode) {
    errors.zipcode = 'Campo obligatorio';
  }

  if (!values.state) {
    errors.state = 'Campo obligatorio';
  }

  if (!values.city) {
    errors.city = 'Campo obligatorio';
  } else if(values.city.length > 30) {
    errors.city = 'No puedes escribir más de 30 caracteres';
  }

  if (!values.town) {
    errors.town = 'Campo obligatorio';
  } else if(values.town.length > 30) {
    errors.town = 'No puedes escribir más de 30 caracteres';
  }

  if (!values.colony) {
    errors.colony = 'Campo obligatorio';
  } else if(values.colony.length > 30) {
    errors.colony = 'No puedes escribir más de 30 caracteres';
  }

  return errors;
};
